module.exports = 'spellSlotTable'
